import axios from "axios";
import { toast } from "sonner";
import { Tooltip } from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";


// Api Handlet for Toast
export const apiHandler = (res, classes = {}, notify = false) => {

  
  if (res?.status === 200) {
    notify && toast.success(res?.data?.message, { style: classes });
    return res.data;
  }

  // if (res?.status === 401) {
  //   alert("User Logged in Elsewhere");
  //   toast.error("User Logged in Elsewhere");
  //   window.location.href = "/";
  // }

  // Extract Error Message Safely //
  const errorMsg = res?.response?.data?.message || res?.message || "Something went wrong";

  // Show toast alert for error
  toast.error(errorMsg);

  // Reject promise so calling code can handle it
  return Promise.reject(new Error(errorMsg));
};

export const ErrLoaderOff = (res, setLoading, delay = 600) => {
  if (res?.status !== 200) {
    setTimeout(() => {
      setLoading(false);
    }, delay);
  }
}

// Loader Handler
export const LoaderFun = (res = {}, setLoading, delay = 600) => {
  if (res?.status === 200) {
    setTimeout(() => {
      setLoading(false);
    }, delay);
  } else {
    setLoading(false);
  }
}

// Total Pages
export const getTotalPages = (totalItems, pageSize = 10) => {
  return Math.ceil(totalItems / pageSize);
}

export const currencyFormatter = () => {
  return '₦';
};

/**
 * Upload a file to S3 using a pre-signed URL
 * @param {string} signedUrl - Pre-signed PUT URL from backend
 * @param {File|Blob} file - File object to upload
 * @returns {Promise<string>} - Resolves to the file's public URL (without query params)
 */
export const uploadToS3 = async (signedUrl, file) => {
  if (!signedUrl || !file) {
    throw new Error("Signed URL and file are required");
  }

  await axios.put(signedUrl, file, {
    headers: {
      "Content-Type": file.type,
    },
  });

  // strip query params (everything after '?') to get the public file URL
  return signedUrl.split("?")[0];
};

export function formatDateTime(isoString) {
  if (!isoString) return "";

  const date = new Date(isoString);

  const optionsDate = { year: "numeric", month: "2-digit", day: "2-digit" };
  const optionsTime = { hour: "2-digit", minute: "2-digit", second: "2-digit" };

  const formattedDate = date.toLocaleDateString("en-GB", optionsDate); // 25/09/2025
  const formattedTime = date.toLocaleTimeString("en-GB", optionsTime); // 12:56:20

  return { date: formattedDate, time: formattedTime };
}

export const delayedNavigate = (navigate, path, data = {}, delay = 1000) => {
  setTimeout(() => {
    navigate(path, data);
  }, delay);
};


export const textFormatter = (name, count) => {
  return (
    name?.length > count ? (
      <Tooltip title={name} arrow>
        <span> {name.slice(0, count) + '...'} </span>
      </Tooltip>
    ) : (
      <>
        {name}
      </>
    )
  );
};

// 1 - Pending, 
// 2 - Assigned, 3 - Verified, 4 - Completed,
// 5 - Cancel, 6 - Allocating, 
// 7 - Rejected, 8 - On The Way
export const OrderStatus = (status) => {
  const statusMap = {
    1: "Pending",
    2: "Driver Assigned",
    3: "Verified",
    4: "Completed",
    5: "Cancelled",
    6: "Allocating",
    7: "Rejected",
    8: "On The Way",
  };
  return statusMap[status] || "Pending";
};

export const statusStyles = {
  Pending: {
    bgcolor: "#FFF4E5",
    color: "#ED6C02",
    border: "1px solid #ED6C0250",
  },
  "Driver Assigned": {
    bgcolor: "#E3F2FD",
    color: "#0288D1",
    border: "1px solid #0288D150",
  },

  "On The Way": {
    bgcolor: "#E3F2FD",
    color: "#0288D1",
    border: "1px solid #0288D150",
  },
  Verified: {
    bgcolor: "#E8F5E9",
    color: "#2E7D32",
    border: "1px solid #2E7D3250",
  },
  Completed: {
    bgcolor: "#C8E6C9",
    color: "#1B5E20",
    border: "1px solid #1B5E2050",
  },
  Cancelled: {
    bgcolor: "#FFEBEE",
    color: "#D32F2F",
    border: "1px solid #D32F2F50",
  },
  Allocating: {
    bgcolor: "#EDE7F6",
    color: "#5E35B1",
    border: "1px solid #5E35B150",
  },
  Rejected: {
    bgcolor: "#FFEBEE",
    color: "#D32F2F",
    border: "1px solid #D32F2F50",
  },
  Delivery: {
    bgcolor: "#E8F5E9",
    color: "#2E7D32",
    border: "1px solid #2E7D3250",
  },
};

// deliveryType - 1 (Delivery)
// deliveryType - 2 (Pickup)
export const DeliveryType = (type) => {
  const typeMap = {
    1: "Delivery",
    2: "Pickup",
  };
  return typeMap[type];
}

// Model Width Props
export const widthData = { width: { xs: "95%", sm: 400, md: 450 } };

// transportType
export const transportType = (type) => {
  const typeMap = {
    0: "None",
    1: "Light",
    2: "Heavy",
  }

  return typeMap[type];
}

// transportType
export const availableType = (type) => {
  const typeMap = {
    1: "available",
    2: "unavailable",
  }

  return typeMap[type];
}

export const Number2Decimal = (value, count = 1) => {
  const num = Number(value || 0);

  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: count,
    maximumFractionDigits: count,
  }).format(num);
};


export const isOpenNow = (openTime, closeTime, serverTimeUtc) => {
  if (!openTime || !closeTime) return false;

  dayjs.extend(utc);
  // console.log("isOpenNow", serverTimeUtc);

  // Normalize NOW into fixed day
  const refDate = "1970-01-01";
  const nowUTC = dayjs.utc(serverTimeUtc);
  const nowStr = nowUTC.format("HH:mm:ss");
  let now = dayjs.utc(`${refDate} ${nowStr}`);

  // Normalize open/close times
  let open = dayjs.utc(`${refDate} ${openTime}`);
  let close = dayjs.utc(`${refDate} ${closeTime}`);

  // If overnight (close < open), add +1 day to close
  if (close.isBefore(open)) {
    close = close.add(1, "day");
    if (now.isBefore(open)) {
      // Now might also be next-day time
      now = now.add(1, "day");
    }
  }

  return now.isAfter(open) && now.isBefore(close);
};




